import { render, staticRenderFns } from "./favorite-group-select.vue?vue&type=template&id=2079656b"
import script from "./favorite-group-select.vue?vue&type=script&lang=js"
export * from "./favorite-group-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports